import axios from 'axios';
import RestService from '../../helpers/RestService';
import moment from 'moment';
import {toastr} from 'react-redux-toastr'

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';

export function setCardKey(key, data) {
  return async (dispatch) => {
    dispatch({type: "SET_CARD_KEY", key, data})
  }
}

export function updateCard(body) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_CARD_KEY', key: 'loaded', data: false})
      const {data} = await axios.post('/api/card/patch', {
        ...body,
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        // dispatch({type: 'UPDATE_CARD', data: payload});
        dispatch({type: 'SET_CARD_KEY', key: 'loaded', data: true})
        dispatch({type: 'DELETE_CARD_TRASHED', data: body.id});
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'}) 
    }
  }
}

export function getCards() {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_CARD_KEY', key: 'loaded', data: false})
      const {data} = await axios.get('/api/card/trashed');

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'SET_CARD_KEY', key: 'list_trashed', data: payload})
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      dispatch({type: 'SET_CARD_KEY', key: 'list_trashed', data: []})
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
      
    }
  }
}

export async function getCardData() {
  try {
    const categories = await axios.get('/api/category-card/getall');
    const subjects = await axios.get('/api/subject-card/get');
    return {
      categories: categories.data.payload,
      subjects: subjects.data.payload,
    }
  } catch (error) {
    return {
      categories: [],
      subjects: [],
    } 
  }
}


export function deleteCard(id) {
  return async (dispatch, props) => {
    console.log("🚀 ~ file: actions.js ~ line 47 ~ return ~ props", props)
    try {
      dispatch({type: 'SET_CARD_KEY', key: 'loaded', data: false})
      const {data} = await axios.post('/api/card/deletetrashed', { id });

      if(data.errcode == 200) {
        dispatch({type: 'DELETE_CARD_TRASHED', data: id});
        return data.payload;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
     
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
    }
  }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/CardTrashed/actions.js